import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { bateau } from './api';
import './Dashboard.css';

function Bateaux() {
  const [bateaux, setBateaux] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingBateau, setEditingBateau] = useState(null);
  const [selectedBateau, setSelectedBateau] = useState(null);
  const [formData, setFormData] = useState({ 
    nom: '', 
    type: 'voilier', 
    nb_moteurs: 1,
    longueur: '', 
    largeur: '', 
    tirantEau: '', 
    tirantAir: '' 
  });
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  useEffect(() => { 
    loadBateaux(); 
  }, []);

  const loadBateaux = async () => {
    try {
      const response = await bateau.getAll();
      setBateaux(response.data);
      setLoading(false);
    } catch (err) {
      console.error(err);
      if (err.response?.status === 401) navigate('/login');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = {
        nom: formData.nom,
        type: formData.type,
        nb_moteurs: parseInt(formData.nb_moteurs) || 1,
        longueur: formData.longueur ? parseFloat(formData.longueur) : null,
        largeur: formData.largeur ? parseFloat(formData.largeur) : null,
        tirant_eau: formData.tirantEau ? parseFloat(formData.tirantEau) : null,
        tirant_air: formData.tirantAir ? parseFloat(formData.tirantAir) : null,
      };
      
      if (editingBateau) {
        await bateau.update(editingBateau.id, data);
      } else {
        await bateau.create(data);
      }
      
      setShowForm(false);
      setEditingBateau(null);
      setFormData({ nom: '', type: 'voilier', nb_moteurs: 1, longueur: '', largeur: '', tirantEau: '', tirantAir: '' });
      loadBateaux();
    } catch (err) {
      alert(editingBateau ? 'Erreur lors de la modification' : 'Erreur lors de la création du bateau');
    }
  };

  const handleEdit = (b) => {
    setEditingBateau(b);
    setFormData({
      nom: b.nom,
      type: b.type || 'voilier',
      nb_moteurs: b.nb_moteurs || 1,
      longueur: b.longueur || '',
      largeur: b.largeur || '',
      tirantEau: b.tirant_eau || '',
      tirantAir: b.tirant_air || '',
    });
    setShowForm(true);
  };

  const handleDelete = async (id, nom) => {
    if (window.confirm(`Supprimer ${nom} ?`)) {
      try { 
        await bateau.delete(id); 
        loadBateaux(); 
      } catch (err) { 
        alert('Erreur lors de la suppression'); 
      }
    }
  };

  const handleSelectBateau = (b) => {
    setSelectedBateau(b);
  };

  if (loading) return (
    <div className="dashboard">
      <div style={{ textAlign: 'center', padding: '50px' }}>Chargement...</div>
    </div>
  );

  return (
    <div className="dashboard">
      <header className="dashboard-header">
        <h1>🛥️ Mes Bateaux</h1>
        <p className="date">Gérez votre flotte</p>
      </header>

      <div style={{ marginBottom: '20px', textAlign: 'center' }}>
        <button 
          onClick={() => { 
            setEditingBateau(null); 
            setFormData({ nom: '', type: 'voilier', nb_moteurs: 1, longueur: '', largeur: '', tirantEau: '', tirantAir: '' }); 
            setShowForm(true); 
          }} 
          className="btn btn-primary"
          style={{ fontSize: '1.1rem', padding: '15px 30px' }}
        >
          ➕ Ajouter un bateau
        </button>
      </div>

      {showForm && (
        <div style={{ 
          position: 'fixed', 
          top: 0, 
          left: 0, 
          right: 0, 
          bottom: 0, 
          background: 'rgba(0,0,0,0.7)', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center', 
          zIndex: 1000 
        }} onClick={() => { setShowForm(false); setEditingBateau(null); }}>
          <div style={{ 
            background: 'white', 
            padding: '30px', 
            borderRadius: '16px', 
            width: '90%', 
            maxWidth: '500px', 
            maxHeight: '90vh', 
            overflowY: 'auto' 
          }} onClick={(e) => e.stopPropagation()}>
            <h2 style={{ marginTop: 0, color: '#667eea' }}>
              🚤 {editingBateau ? 'Modifier le bateau' : 'Nouveau Bateau'}
            </h2>
            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Nom du bateau *</label>
                <input 
                  type="text" 
                  value={formData.nom} 
                  onChange={(e) => setFormData({ ...formData, nom: e.target.value })} 
                  style={{ width: '100%', padding: '10px', fontSize: '16px', border: '2px solid #ddd', borderRadius: '8px', boxSizing: 'border-box' }} 
                  required 
                />
              </div>

              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Type *</label>
                <select 
                  value={formData.type} 
                  onChange={(e) => setFormData({ ...formData, type: e.target.value })} 
                  style={{ width: '100%', padding: '10px', fontSize: '16px', border: '2px solid #ddd', borderRadius: '8px' }} 
                  required
                >
                  <option value="voilier">⛵ Voilier</option>
                  <option value="catamaran">⛵ Catamaran</option>
                  <option value="moteur">🚤 Bateau à moteur</option>
                </select>
              </div>

              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Nombre de moteurs</label>
                <select 
                  value={formData.nb_moteurs} 
                  onChange={(e) => setFormData({ ...formData, nb_moteurs: e.target.value })} 
                  style={{ width: '100%', padding: '10px', fontSize: '16px', border: '2px solid #ddd', borderRadius: '8px' }}
                >
                  <option value="1">1 moteur</option>
                  <option value="2">2 moteurs</option>
                </select>
              </div>

              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Longueur (m)</label>
                <input 
                  type="number" 
                  step="0.1" 
                  value={formData.longueur} 
                  onChange={(e) => setFormData({ ...formData, longueur: e.target.value })} 
                  style={{ width: '100%', padding: '10px', fontSize: '16px', border: '2px solid #ddd', borderRadius: '8px', boxSizing: 'border-box' }} 
                />
              </div>

              <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
                <button 
                  type="button" 
                  onClick={() => { setShowForm(false); setEditingBateau(null); }} 
                  className="btn btn-secondary"
                  style={{ flex: 1 }}
                >
                  Annuler
                </button>
                <button 
                  type="submit" 
                  className="btn btn-primary"
                  style={{ flex: 1 }}
                >
                  {editingBateau ? 'Enregistrer' : 'Créer'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {bateaux.length === 0 ? (
        <div className="empty-state">
          <p style={{ fontSize: '18px' }}>Aucun bateau enregistré</p>
          <p>Cliquez sur "Ajouter un bateau" pour commencer</p>
        </div>
      ) : (
        <div className="boats-grid">
          {bateaux.map((b) => (
            <div 
              key={b.id} 
              className={`boat-card ${selectedBateau?.id === b.id ? 'selected' : ''}`}
              style={{ position: 'relative' }}
            >
              {selectedBateau?.id === b.id && (
                <div style={{
                  position: 'absolute',
                  top: '10px',
                  right: '10px',
                  background: '#4caf50',
                  color: 'white',
                  width: '30px',
                  height: '30px',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '1.2rem',
                  fontWeight: 'bold'
                }}>
                  ✓
                </div>
              )}

              <h3 onClick={() => handleSelectBateau(b)} style={{ cursor: 'pointer' }}>
                {b.nom}
              </h3>
              <p className="boat-type">
                {b.type === 'voilier' && '⛵ Voilier'}
                {b.type === 'moteur' && '🚤 Moteur'}
                {b.type === 'catamaran' && '⛵ Catamaran'}
              </p>
              
              <div style={{ marginTop: '15px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <button 
                  onClick={() => navigate(`/bateau/${b.id}/navigation`)}
                  className="btn btn-primary"
                  style={{ width: '100%', padding: '10px', fontSize: '0.9rem' }}
                >
                  🗺️ Navigation GPS
                </button>
                <button 
                  onClick={() => navigate(`/bateau/${b.id}`)}
                  className="btn btn-success"
                  style={{ width: '100%', padding: '10px', fontSize: '0.9rem', background: '#3498db' }}
                >
                  ✅ Checklist
                </button>
              </div>

              <div style={{ marginTop: '10px', display: 'flex', gap: '5px' }}>
                <button 
                  onClick={() => handleEdit(b)} 
                  style={{ 
                    flex: 1,
                    background: '#95a5a6', 
                    color: 'white', 
                    border: 'none', 
                    borderRadius: '5px', 
                    padding: '8px', 
                    cursor: 'pointer', 
                    fontSize: '0.85rem' 
                  }}
                >
                  ✏️
                </button>
                <button 
                  onClick={() => handleDelete(b.id, b.nom)} 
                  style={{ 
                    flex: 1,
                    background: '#e74c3c', 
                    color: 'white', 
                    border: 'none', 
                    borderRadius: '5px', 
                    padding: '8px', 
                    cursor: 'pointer', 
                    fontSize: '0.85rem' 
                  }}
                >
                  🗑️
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      <div className="dashboard-nav">
        <button onClick={() => navigate('/')} className="nav-btn">
          ← Retour au Dashboard
        </button>
      </div>

      <style>{`
        .boat-card.selected {
          border: 3px solid #4caf50;
          box-shadow: 0 4px 16px rgba(76, 175, 80, 0.3);
        }
      `}</style>
    </div>
  );
}

export default Bateaux;